import getWithFallback from "../utils/ajax";
import inx from "inx";

export default (function () {

    return {
        categoryTop: 21,

        getFeedData: function (sourceId, urlTemplate, fallbackLang, categoryId, getFeedDataCallback) {
            //https://news.inbox.lv/api/news?category=3&domain=inbox.lv&language=ru&limit=200&offset=0&source=33

            const currLang = document.querySelector('html').getAttribute('lang');

            const feedUrl = this.getFeedLink(urlTemplate, sourceId, categoryId, currLang);
            const feedFallbackUrl = this.getFeedLink(urlTemplate, sourceId, categoryId, fallbackLang);
            getWithFallback(feedUrl, feedFallbackUrl, function(data) {
                getFeedDataCallback(data);
            });
        },
        getFeedLink: function (url, sourceId, categoryId, lang) {
            return url
                .replace('#SITE#', inx.site)
                .replace('#SOURCE_ID#', sourceId)
                .replace('#CATEGORY_ID#', categoryId)
                .replace('#LNG#', lang)
            ;
        }
    };
}());
